import axios from 'axios'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import store from '../../../Store'
import {cancelUsersFormDispatch, userFormServerValidationErrors} from '../../../pages/user/form/UserForm-Actions'
import {scrollToError} from '../../../helpers/ScrollHelper'

function _success(success) {
    return {type: 'UPDATE_ORGANIZATION_USER_SUCCESS', success}
}

function _error(error) {
    return {type: 'UPDATE_ORGANIZATION_USER_ERROR', error}
}

function _processing(processing) {
    return {type: 'UPDATE_ORGANIZATION_USER_PROCESSING', processing}
}

function updateOrganizationUser(organization_id = null, customer_id) {
    return (dispatch, getState) => {

        let {organizationUserForm, organizationDashboard} = getState()
        let org_id = organization_id || organizationDashboard.data.organization_id;
        dispatch(_success(null))
        dispatch(_error(null))
        dispatch(_processing(true))

        axios({
            url: apiBaseUrl(`admin/organizations/${org_id}/customers/${customer_id}`),
            method: 'put',
            dataType: 'json',
            data: JSON.parse(JSON.stringify(organizationUserForm.data.payload)),
            headers: {
                'Authorization': 'Bearer ' + loginToken()
            }
        })
            .then(function (res) {
                dispatch(_success(res))
                dispatch(_processing(false))
                handleSuccess(res)
                store.dispatch(cancelUsersFormDispatch())

            }).catch(function (error) {
            dispatch(_error(error.response.data.message))
            dispatch(_processing(false))
            handleError(error)

            store.dispatch(cancelUsersFormDispatch())
            if (error.response && error.response.status === 422) {
                store.dispatch(userFormServerValidationErrors(error.response.data.errors))
                scrollToError()
            }
        })
    }
}

export default updateOrganizationUser
